import style from './BottomButton.module.css';

interface Props {
  children: React.ReactNode;
}

export default function BottomButton({ children }: Props) {
  return <div className={style.bottomContainer}>{children}</div>;
}
